(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvLocalStorage', ['$window', 'vv', 'vvCookies', 'xdLocalStorage', '$q', '$timeout',
  function($window, vv, vvCookies, xdLocalStorage, $q, $timeout) {
    var isLocalStorageAvailable = function() {
      try {
        if (!$window.sessionStorage)  return false;
        $window.sessionStorage.setItem('test', '1');
        $window.sessionStorage.removeItem('test');
        return true;
      } catch (error) {
        return false;
      }
    };

    if ($window.localStorage && $window.localStorage.length > 0) {
        $window.localStorage.clear();
    }

    this.isAvailable = isLocalStorageAvailable;

    this.getSnsFriendsStorageKey = function(user) {
      return '_vvsns_' + user.fb_id + '_';
    };

    if (!isLocalStorageAvailable()) {
      console.warn('no local storage, use cookies instead');
      var addMethods = function (o, cookieObj) {
        var storage;
        try {
          storage = angular.fromJson(vv.urlbase64.decode(cookieObj.get('localStorage'))) || {};
        } catch (e) {
          console.log('error decoding local storage');
          storage = {};
        }

        o.get = function (name) {
          return storage[name];
        };

        o.getAndRemove = function (name) {
          var value = storage[name];
          delete storage[name];
          cookieObj.set('localStorage', vv.urlbase64.encode(angular.toJson(storage)), null, Infinity);
          return value;
        };

        o.set = function (name, value) {
          storage[name] = value;
          cookieObj.set('localStorage', vv.urlbase64.encode(angular.toJson(storage)), null, Infinity);
        };

        o.remove = function (name) {
          delete storage[name];
          cookieObj.set('localStorage', vv.urlbase64.encode(angular.toJson(storage)), null, Infinity);
        };

        o.clear = function () {
          storage = {};
          cookieObj.remove('localStorage');
        };
      };

      addMethods(this, vvCookies);

      var _xd = {};
      addMethods(_xd, vvCookies.global);

      var xd = {};
      xd.get = function(name) {
        return $q.when(_xd.get(name)).catch(function() { return null; });
      };
      xd.getAndRemove = function(name) {
        return $q.when(_xd.getAndRemove(name)).catch(function() { return null; });
      };
      xd.set = function(name, value) {
        return $q.when(_xd.set(name, value)).catch(function() { return null; });
      };
      xd.remove = function(name) {
        return $q.when(_xd.remove(name)).catch(function() { });
      };
      xd.clear = function() {
        return $q.when(_xd.clear()).catch(function() { });
      };
      this.xd = xd;
      return;
    }

    this.get = function(name) {
      try {
        var value = angular.fromJson($window.sessionStorage.getItem(name));
        // console.log('ls-get', name, value);
        return value;
      } catch (e) {
        console.log('vvLocalStorage get error', e);
        return null;
      }
    };

    this.getAndRemove = function(name) {
      try {
        var value = angular.fromJson($window.sessionStorage.getItem(name));
        $window.sessionStorage.removeItem(name);
        // console.log('ls-getAndRemove', name, value);
        return value;
      } catch (e) {
        console.log('vvLocalStorage getAndRemove error', e);
        return null;
      }
    };

    this.set = function(name, value) {
      try {
        // console.log('ls-set', name, value);
        $window.sessionStorage.setItem(name, angular.toJson(value));
      } catch (e) {
        console.log('vvLocalStorage set error', e);
      }
    };

    this.remove = function(name) {
      try {
        // console.log('ls-remove', name);
        $window.sessionStorage.removeItem(name);
      } catch (e) {
        console.log('vvLocalStorage remove error', e);
      }
    };

    this.clear = function() {
      try {
        // console.log('ls-clear');
        $window.sessionStorage.clear();
      } catch (e) {
        console.log('vvLocalStorage clear error', e);
      }
    };

    var xd = {};

    var initXdLocalStorage = (function () {
      var baseHost = vv.getVvMetaData('xd_base');
      var useXdLocalStorage = baseHost && baseHost.match(/[^:]+/)[0] != document.location.hostname;
      var xdLocalStorageInitialized = false;

      return function() {
        if (!useXdLocalStorage)
        return $q.reject('not need to use xdLocalStorage');

        if (xdLocalStorageInitialized)
        return $q.when();

        var timeoutDeferred = $q.defer();
        var timeoutTimer = $timeout(function() {
          timeoutDeferred.reject('timeout');
          console.log('xdLocalStroage init timeout');
          useXdLocalStorage = false;
        }, 3000);
        return $q.all([xdLocalStorage.init(
          {
            iframeUrl: '//' + baseHost + '/xd/xdSessionStorage.html?_v=2'
          }
        ).then(function () {
          $timeout.cancel(timeoutTimer);
          timeoutDeferred.resolve(null);
          xdLocalStorageInitialized = true;
          console.log('xdLocalStorage init');
        }), timeoutDeferred.promise]);
      }
    })();

    var nonXd = this;

    xd.override = function(obj) {
      ['get', 'getAndRemove', 'set', 'remove', 'clear'].forEach(function (method) {
        if (method in obj) {
          xd[method] = obj[method];
        } else {
          var msg = "Failed to override xd. method not found: " + method;
          console.log(msg);
          throw msg;
        }
      });
    };

    xd.get = function(name) {
      return initXdLocalStorage().then(function() {
        return xdLocalStorage.getItem(name).then(function(response) {
          if (response.value != null) {
            var value = angular.fromJson(response.value);
            nonXd.set(name, value);
            return value;
          } else {
            return nonXd.get(name);
          }
        });
      }, function() {
        return $q.when(nonXd.get(name));
      });
    };
    xd.getAndRemove = function(name) {
      return initXdLocalStorage().then(function() {
        return xd.get(name).then(function(value) {
          xd.remove(name);
          nonXd.remove(name);
          if (value != null) {
            return value;
          } else {
            return nonXd.getAndRemove(name);
          }
        });
      }, function() {
        return $q.when(nonXd.getAndRemove(name));
      });
    };
    xd.set = function(name, value) {
      nonXd.set(name, value);
      return initXdLocalStorage().then(function() {
        xdLocalStorage.setItem(name, angular.toJson(value));
      }, function() {
        return $q.when();
      });
    };
    xd.remove = function(name) {
      nonXd.remove(name);
      return initXdLocalStorage().then(function() {
        return xdLocalStorage.removeItem(name);
      }, function() {
        return $q.when();
      });
    };
    xd.clear = function() {
      nonXd.clear();
      return initXdLocalStorage().then(function() {
        return xdLocalStorage.clear();
      }, function () {
        return $q.when();
      });
    };

    this.xd = xd;
  }]);
})(window, window.angular);
